"use client";

import { c as _c } from "react/compiler-runtime";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, cn, useIsTablet } from "@saridana-core/react-ui-kit";
import { TProductComparisonCard, TProductComparisonSection } from "@shared/types";
import { ButtonLink, HtmlParser, SectionHeading } from "@shared/ui";
import { ReplacementsMap } from "@shared/ui/html-parser";
import { mapAttribsToProps } from "@shared/utils";
import { domToReact, HTMLReactParserOptions } from "html-react-parser";
import Image from "next/image";
import Link from "next/link";
export function ProductComparisonSection(t0) {
  const $ = _c(14);
  const {
    title,
    description,
    cards
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      a: _temp,
      p: _temp2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const replacementsMap = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      background: "linear-gradient(222.34deg, #1DB0DE 23.84%, #265E78 92.05%)"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <div className="max-w-[80%] lg:max-w-[60%] mx-auto mb-12 sm:mb-[72px] lg:mb-20"><SectionHeading titleClassName="text-center text-white max-w-full" title={title} /></div>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== cards) {
    t4 = cards?.length > 0 && <ProductComparisonCards cards={cards} />;
    $[4] = cards;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div>{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== description) {
    t6 = <div className="hidden lg:block text-white leading-[134%] text-2xl text-center max-w-[90%] md:max-w-[70%] mx-auto mt-[60px]"><HtmlParser data={description} redefine={replacementsMap} /></div>;
    $[8] = description;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t6) {
    t7 = <section className="py-20 sm:py-[100px] lg:py-[120px] relative" style={t2}><div className="container relative"><div>{t3}{t5}{t6}</div></div></section>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp2(domNode_0, options_0) {
  const attribs = domNode_0.attribs || {};
  const props = mapAttribsToProps(attribs);
  const mergedClass = cn("leading-[140%]", props.className);
  delete props.className;
  return <p {...props} className={mergedClass} style={{
    color: "rgba(255, 255, 255, 0.8)"
  }}>{domToReact(domNode_0.children, options_0)}</p>;
}
function _temp(domNode, options) {
  const href = domNode.attribs.href;
  return <Link href={href} target="_blank" className="hover:opacity-80 text-white font-semibold">{domToReact(domNode.children, options)}</Link>;
}
export function ProductComparisonCards(t0) {
  const $ = _c(7);
  const {
    cards
  } = t0;
  const isTablet = useIsTablet();
  let t1;
  let t2;
  if ($[0] !== cards || $[1] !== isTablet) {
    const orderedCards = isTablet ? cards.sort(_temp3) : [...cards];
    t1 = "grid grid-cols-1 lg:grid-cols-2 justify-center items-center gap-6 sm:gap-10 lg:gap-8 w-full xl:max-w-[70%] mx-auto";
    t2 = orderedCards?.map(_temp4);
    $[0] = cards;
    $[1] = isTablet;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <><div className={t1}>{t2}</div></>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp4(item, index) {
  return <div key={`benefit-card-${index}`} className="w-full rounded-2xl overflow-hidden" style={{
    background: item.highlighted ? "linear-gradient(180deg, #BEE9F9 0%, #F7FDFC 100%)" : ""
  }}>{item.highlighted && <h3 className={cn("text-center text-xl font-bold leading-[150%] tracking-wider py-2")} style={{
      background: "linear-gradient(90deg, #0F8CBA 0%, #0C3245 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent"
    }}>Paling Untung</h3>}<Card className={cn("border-none shadow-none md:min-w-[26rem]", item.highlighted ? "mx-2" : "w-full")}><CardHeader>{item?.icon?.data?.attributes?.url && <Image src={item?.icon?.data?.attributes?.url} height={item?.icon?.data?.attributes?.height} width={item?.icon?.data?.attributes?.width} alt={item?.icon?.data?.attributes?.alternativeText || item?.icon?.data?.attributes?.name || "Comparison Card Icon"} className="w-14 h-14 mb-2" />}<CardTitle className={cn("font-bold text-2xl leading-[134%] mb-2", item?.highlighted ? "text-primary-600" : "")}>{item?.title}</CardTitle><CardDescription className="leading-[146%] text-gray-700 mb-6">{item?.description}</CardDescription><h3 className="font-bold text-4xl md:text-5xl leading-[115%] pb-4" style={item.highlighted ? {
          backgroundImage: "linear-gradient(90deg, #134E67 0%, #1DB0DE 54.25%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent"
        } : {
          color: "black"
        }}>{item?.subtitle}</h3></CardHeader><div className="relative mb-8"><div className={cn("w-full border-b-2 border-dashed", item.highlighted ? "border-primary-900" : "border-gray-200")} /><div className={cn("bg-white text-md font-semibold rounded-full border px-4 text-md absolute z-1 -top-3 left-6", item.highlighted ? "border-primary-900" : "border-gray-200")}>Benefit</div></div><CardContent className="space-y-7 sm:space-y-9">{item?.features?.length > 0 && <div><ProductComparisonFeatures features={item?.features} /></div>}{item.buttonText && item.buttonLink && <ButtonLink text={item.buttonText} target={item.buttonTarget || "_self"} href={item.buttonLink} variant={item.highlighted ? "primary" : "default"} iconClassName="size-6" size="md" icon={item.buttonIcon} className={cn("w-full flex", !item.highlighted ? "border-primary" : "")} />}</CardContent></Card></div>;
}
function _temp3(a, b) {
  return (b.highlighted as any) - (a.highlighted as any);
}
export function ProductComparisonFeatures(t0) {
  const $ = _c(4);
  const {
    features
  } = t0;
  let t1;
  if ($[0] !== features) {
    t1 = features.map(_temp5);
    $[0] = features;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp5(item, index) {
  return <div key={`benefit-comparison-value-${index}`} className="py-1 font-medium text-lg leading-[146%] items-center flex gap-2"><CheckCircleIcon className="size-6 min-w-6 text-primary" /><span className="flex-1">{item}</span></div>;
}